import React                                                      from 'react';
import { render }                                                 from 'react-dom';
import App                                                        from 'components/App';
import { isMobile, isIpad, envCheck,
          queryParams, getParams, setCookie, getCookie }          from 'utils/util';
import BrandPlay                                                  from 'components/brand_play';

require('../mediator/required.js');
require('stores/brand_play_tracking_store');
require('stores/brand_play_layout_store');
require('classlist');
require('utils/browser_class');

const body = document.querySelector('body');

if(isMobile() || isIpad()) {
  body.classList.add('is-mobile');
} else {
  body.classList.add('is-desktop');
}
let cpData = JSON.parse(document.querySelector(`[data-cp]`).getAttribute(`data-cp`));
let lastScn;

$.ajax({
  type: "GET",
  contentType: "application/jsonp",
  url: `//api${envCheck()}.medscape.com/cp/ipplastvisit/user/${(Number(window.s_registered_user_id) / 27.0)}/activities/${cpData.activityId}`,
  dataType: "jsonp",
  timeout: 1000,
  success: function(data) {
    if (typeof data.activities[0].scene != 'undefined') {
      lastScn = Number(data.activities[0].scene.name.split('scn')[1]);
    }
    if (bpInstance.rememberMe && cpData && !bpInstance.tacticIndex){
      if(typeof getParams().startVideo == 'undefined' && lastScn > 0) {
        if(lastScn < bpInstance.videos.length){
          window.bpInstance.initialIndex = lastScn;
        }
      }
    }
  },
  error: function(err){
    console.log(err);
  },
  complete: function(){
  	render((<BrandPlay descriptorJSON={window.bpInstance} />),
   		document.getElementById('jsx_video_player'));
    $(window).trigger('video_player:rendered');
  }
});



// WEBPACK FOOTER //
// ./modules/video/brand_player.js